import { render } from "./BaseWeek.vue?vue&type=template&id=71cefc68&scoped=true"
import script from "./BaseWeek.vue?vue&type=script&lang=js"
export * from "./BaseWeek.vue?vue&type=script&lang=js"

import "./BaseWeek.vue?vue&type=style&index=0&id=71cefc68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cefc68"]])

export default __exports__